import { createStore, compose } from 'redux'
import reducers from '../reducers'

const composeEnhancers = process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__() :
    (f) => f;

export const apartmentStore = createStore(
    reducers,
    compose(composeEnhancers)
);
